import { features } from 'config/profile'

export const IS_PASSWORD_ENABLED = features.LOGIN_METHOD !== 'MAGICLINK'

export const hasNetMeteringProduct = (latestProduct) => {
  try {
      const billing = JSON.parse(latestProduct.billing)
      return billing.charges && Array.from(billing.charges).includes('net_metering')
    } catch (err) {
      return false
    }
}
